import { render, staticRenderFns } from "./newInsuredModal.vue?vue&type=template&id=ad662532&scoped=true&"
import script from "./newInsuredModal.vue?vue&type=script&lang=js&"
export * from "./newInsuredModal.vue?vue&type=script&lang=js&"
import style0 from "./newInsuredModal.vue?vue&type=style&index=0&id=ad662532&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad662532",
  null
  
)

export default component.exports